// LearnCore Frontend - 屏幕方向检测Hook

import { useState, useEffect } from 'react';

interface ScreenOrientation {
  isPortrait: boolean;
  isLandscape: boolean;
  orientation: 'portrait' | 'landscape';
  width: number;
  height: number;
  isSmallDevice: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export function useScreenOrientation(): ScreenOrientation {
  const [orientation, setOrientation] = useState<ScreenOrientation>(() => {
    if (typeof window === 'undefined') {
      return {
        isPortrait: true,
        isLandscape: false,
        orientation: 'portrait',
        width: 1024,
        height: 768,
        isSmallDevice: false,
        isTablet: false,
        isDesktop: true
      };
    }

    const width = window.innerWidth;
    const height = window.innerHeight;
    const isPortrait = height > width;
    const isSmallDevice = width < 768;
    const isTablet = width >= 768 && width < 1024;
    const isDesktop = width >= 1024;

    return {
      isPortrait,
      isLandscape: !isPortrait,
      orientation: isPortrait ? 'portrait' : 'landscape',
      width,
      height,
      isSmallDevice,
      isTablet,
      isDesktop
    };
  });

  useEffect(() => {
    const handleOrientationChange = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isPortrait = height > width;
      const isSmallDevice = width < 768;
      const isTablet = width >= 768 && width < 1024;
      const isDesktop = width >= 1024;

      setOrientation({
        isPortrait,
        isLandscape: !isPortrait,
        orientation: isPortrait ? 'portrait' : 'landscape',
        width,
        height,
        isSmallDevice,
        isTablet,
        isDesktop
      });
    };

    // 监听窗口大小变化
    window.addEventListener('resize', handleOrientationChange);

    // 监听屏幕方向变化（如果支持）
    if (window.screen && window.screen.orientation) {
      window.screen.orientation.addEventListener('change', handleOrientationChange);
    }

    return () => {
      window.removeEventListener('resize', handleOrientationChange);

      if (window.screen && window.screen.orientation) {
        window.screen.orientation.removeEventListener('change', handleOrientationChange);
      }
    };
  }, []);

  return orientation;
}